import { render, staticRenderFns } from "./KuesionerKompetensi.vue?vue&type=template&id=376deedf&scoped=true&lang=html&"
import script from "./KuesionerKompetensi.vue?vue&type=script&lang=js&"
export * from "./KuesionerKompetensi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376deedf",
  null
  
)

export default component.exports